import { Component, OnInit } from '@angular/core';
import {TrustPayService} from "../../trust-pay.service";
import {TrustPayTransaction} from "../../dto/trustPayTransaction";
import {ConfirmDialogComponent} from "../../shared/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import { Location } from '@angular/common';

@Component({
  selector: 'app-trustpay-usercheck',
  templateUrl: './trustpay-usercheck.component.html',
  styleUrls: ['./trustpay-usercheck.component.css']
})
export class TrustpayUsercheckComponent implements OnInit {

  transactions: TrustPayTransaction[] = [];
  transactionSum = 0;
  displayedColumns = ['counterAccount', 'statementDate', 'amount', 'reference', 'description', 'actions'];
  isLoading = false;

  constructor(
    private trustpayService: TrustPayService,
    private dialog: MatDialog,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.loadNeedsCheck();

  }


  loadNeedsCheck() {
    this.isLoading = true;
    this.trustpayService.getNeedsCheck().subscribe(result => {
      let txnSum = 0;
      result.forEach(value => txnSum += value.amount);
      this.transactionSum = txnSum;
      this.transactions = result;
      this.isLoading = false;
    });
  }

  protected readonly TrustPayTransaction = TrustPayTransaction;
  isApproving = false;

  deleteTransaction(id: number) {
    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Delete transaction', text: 'Are you sure you want to delete this transaction?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          this.trustpayService.delete(id).subscribe(
            value => this.loadNeedsCheck()
          );

        }
      });


    this.trustpayService.delete(id);
  }

  approveTransaction(id: number) {
    this.isApproving = true;
    this.trustpayService.confirmUserCheck(id).subscribe(value => {
      this.loadNeedsCheck();
      this.isApproving = false;
    }, error => {
      this.isApproving = false;
    });
  }

  approveTransactions() {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Approve transactions', text: 'Are you sure you want to approve all transactions?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          let ids = this.transactions.map(value => value.id);
          this.isApproving = true;
          this.trustpayService.confirmUserCheckMany(ids).subscribe(value => {
            this.loadNeedsCheck();
            this.isApproving = false;
          }, error => {
            this.isApproving = false;
          });

        }
      });



    return false;
  }

  returnBack() {
    this.location.back();
  }
}
